import React, { FC } from 'react'
import { Backdrop } from '@mui/material'

import theme from '../../styleguide/theme'
import InputAlertWarningNoteDialog from '../../components/InputAlertWarningNoteDialog'
import {
	useInputAlertWarningNoteDialog,
	InputAlertWarningNoteProvider,
} from './useInputAlertWarningNoteDialog'

export { InputAlertWarningNoteProvider }

const InputAlertWarningNoteDialogContainer: FC = () => {
	const { dialogs, removeDialog, saveNote, updateNote, getNote } =
		useInputAlertWarningNoteDialog()

	return (
		<>
			<Backdrop
				open={dialogs.some(d => d.isOpen)}
				style={{ zIndex: theme.zIndex.modal }}
			/>
			{dialogs.map(
				dialog =>
					dialog.isOpen && (
						<InputAlertWarningNoteDialog
							key={`${dialog.instrument}-${dialog.key}`}
							isOpen={dialog.isOpen}
							warningNote={getNote(dialog.instrument, dialog.key)}
							onNoteChange={note =>
								updateNote(dialog.instrument, dialog.key, note)
							}
							onSave={() => {
								const noteValue = getNote(dialog.instrument, dialog.key)
								saveNote(dialog.instrument, dialog.key, noteValue)
							}}
							onClose={() => removeDialog(dialog.instrument, dialog.key)}
							instrument={dialog.instrument}
							fieldKey={dialog.key}
							hideBackdrop={true}
							index={dialog.index}
						/>
					),
			)}
		</>
	)
}

export default InputAlertWarningNoteDialogContainer
